<template>
  <v-container fluid pa-0>
    <v-row v-if="routes.length == 0">
      <add-btn
        label="Add New Route"
        @click="onAddRoute"
        icon="mdi-map-marker-plus"
      ></add-btn>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-container fluid py-0>
          <v-row justify="end" align="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small v-on="on" class="ml-2" fab @click="onCreateRoute">
                  <v-icon small>mdi-file-plus-outline</v-icon>
                </v-btn>
              </template>
              Create New Route
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="ml-2"
                  fab
                  dark
                  color="primary"
                  @click="onAddRoute"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
              Add Route
            </v-tooltip>
          </v-row>
        </v-container>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-data-table :headers="headers" :items="routes">
                <template v-slot:item.actions="{ item }">
                  <default-list-actions
                    :item="item"
                    @deleteItem="deleteItem"
                    @viewItem="viewItem"
                    :hide-view="false"
                    hide-edit
                  ></default-list-actions>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <add-route-dialog
      v-if="false"
      :show="showAddRouteDialog"
      @close="showAddRouteDialog = false"
      @create="onCreate"
    ></add-route-dialog>
    <routes-dialog
      :show="showAddRouteDialog"
      @close="showAddRouteDialog = false"
      @create="onCreate"
    ></routes-dialog>
    <route-details-dialog
      :show="showRouteDetailsDialog"
      @close="showRouteDetailsDialog = false"
      v-model="selectedRoute"
      @save="onRouteSave"
      show-tags
      show-date
      show-sequence
      show-color-picker
      :date-range="dateRange"
    ></route-details-dialog>
    <v-row v-if="debug">{{ dateRange }}</v-row>
  </v-container>
</template>

<script>
import AddBtn from "../../shared/AddBtn";
import DefaultListActions from "../../shared/DefaultListActions";
import AddRouteDialog from "./AddRouteDialog";
import RouteDetailsDialog from "./RouteDetailsDialog";
import RoutesDialog from "./fb/RoutesDialog";
import gql from "graphql-tag";
import EventBus from "../../../../store/event-bus";
const CREATE_IT_ROUTE = gql`
  mutation createItineraryRoute(
    $itineraryId: ID!
    $route: ItineraryRouteInput!
  ) {
    createItineraryRoute(itineraryId: $itineraryId, route: $route) {
      id
      name
      code
      description
      coordinates
      tags
      color
      pois {
        edges {
          node {
            id
            name
            lng
            lat
            description
            radius
            audio
            type {
              id
              name
              iconName
              iconSVG
            }
          }
        }
      }
    }
  }
`;
const UPDATE_IT_ROUTE = gql`
  mutation updateItineraryRoute($id: ID!, $route: ItineraryRouteInput!) {
    updateItineraryRoute(id: $id, route: $route) {
      id
      name
      code
      description
      coordinates
      tags
      color
      date
      sequence
      pois {
        edges {
          node {
            id
            name
            lng
            lat
            description
            radius
            audio
            type {
              id
              name
              iconName
              iconSVG
            }
          }
        }
      }
    }
  }
`;
const DELETE_IT_ROUTE = gql`
  mutation deleteItineraryRoute($id: ID!) {
    deleteItineraryRoute(id: $id) {
      id
    }
  }
`;
export default {
  name: "itinerary-routes",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    itineraryId: {
      type: String,
      default: () => "",
    },
    itinerary: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    AddBtn,
    DefaultListActions,
    AddRouteDialog,
    RouteDetailsDialog,
    RoutesDialog, //uses fb
  },

  data() {
    return {
      debug: false,
      showAddRouteDialog: false,
      showRouteDetailsDialog: false,
      selectedRoute: null,
      routes: this.value && this.value.length > 0 ? [...this.value] : [],
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Code",
          value: "code",
          name: "code",
        },
        {
          text: "Description",
          value: "description",
          name: "description",
        },
        {
          text: "Tags",
          value: "tags",
          name: "tags",
        },
        {
          text: "Sequence",
          value: "sequence",
          name: "sequence",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    dateRange() {
      if (this.itinerary) {
        return {
          start: this.itinerary.startDate,
          end: this.itinerary.endDate,
        };
      }
      return null;
    },
  },

  watch: {
    value(newRoutes) {
      this.routes = [...newRoutes];
    },
  },

  methods: {
    onAddRoute() {
      this.showAddRouteDialog = true;
    },
    onCreateRoute() {
      this.selectedRoute = { name: "New Route", coordinates: "" };
      this.showRouteDetailsDialog = true;
    },
    onRouteSave(payload) {
      if (this.selectedRoute.id) {
        this.$apollo
          .mutate({
            mutation: UPDATE_IT_ROUTE,
            variables: { id: this.selectedRoute.id, route: { ...payload } },
          })
          .then((result) => {
            this.showRouteDetailsDialog = false;
            //update local list
            const res = { ...result.data.updateItineraryRoute };
            const editedIndex = this.routes.findIndex((r) => r.id == res.id);
            Object.assign(this.routes[editedIndex], { ...res });
            EventBus.$emit("update-tags");
          })
          .catch((error) => console.error(error));
      } else {
        this.createItineraryRoute(payload);
      }
    },
    deleteItem(item) {
      //console.log(item);
      this.$apollo
        .mutate({
          mutation: DELETE_IT_ROUTE,
          variables: {
            id: item.id,
          },
        })
        .then((result) => {
          this.routes = [
            ...this.routes.filter(
              (r) => r.id != result.data.deleteItineraryRoute.id
            ),
          ];
        })
        .catch((error) => console.log(error));
    },
    viewItem(item) {
      this.selectedRoute = { ...item };
      this.showRouteDetailsDialog = true;
    },
    onCreate(payload) {
      this.showAddRouteDialog = false;
      this.createItineraryRoute(payload);
    },
    createItineraryRoute(payload) {
      this.$apollo
        .mutate({
          mutation: CREATE_IT_ROUTE,
          variables: {
            itineraryId: this.itineraryId,
            route: {
              name: payload.name,
              code: payload.code,
              description: payload.description,
              coordinates: payload.coordinates,
              tags: payload.tags,
              color: payload.color,
              pois: payload.pois,
            },
          },
        })
        .then((result) => {
          this.routes.push({ ...result.data.createItineraryRoute });
          if (this.showRouteDetailsDialog) {
            this.showRouteDetailsDialog = false;
          }
          EventBus.$emit("update-tags");
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/routes/ItineraryRoutes.vue